import { AlertType, AlertRecord, AlertInfo } from './Types';
import * as Config from '../config';
import * as AlertTypes from './alertTypes/';
export * from './Types';
export * as Types from './alertTypes/';
import { State } from "../status/Types";

/**
 * @deprecated
 */
export function findByType(type:AlertType|string) {
    return findClass(type);
}
    
export function findClass(type:AlertType|string) {
    return Object
            .values(AlertTypes)
            .find((ty) => {
                return Array.isArray(ty.type) ? 
                    (ty.type as string[]).indexOf(type) !== -1 :
                    ty.type === type
            });
}


export function getByType(alert:AlertRecord, config:Config.AllConfig):AlertTypes.AlertLogic {
    let TypeClass = this.findClass(alert.type);

    return new TypeClass(alert, config);
}

export function getInfo(alert:AlertRecord, config:Config.AllConfig, states:State[]):AlertInfo {
    const generatorClass = findClass(alert.type)
    if (generatorClass) {
        // Calling child class's static getInfo()
        // It will instantiate itself (the child class) and call it's own getInfo()
        return generatorClass.getInfo(alert, config, states);
    }
    // Calling base class's static getInfo()
    // It will instantiate itself (the base class) and call it's own getInfo()
    const alertInfo = AlertTypes.AlertLogic.getInfo(alert, config, states);
    return alertInfo;
}

export function getClass(type) {
    const generatorClass = findClass(type);
    if (generatorClass) {
        return generatorClass;
    }
    return AlertTypes.AlertLogic;
}

export function mock(type:AlertType, config?:Config.AllConfig, subType?:string):AlertRecord[] {
    let generatorClass = findClass(type);
    if (!generatorClass)
        return null;
    let mocked = generatorClass.mock(type, config, subType);
    if (Array.isArray(mocked)) {
        return mocked;
    }
    return [ mocked ];
}

export function localFromRecord(alert:AlertRecord) {
    let rec = {
        UUID: alert.uuid,
        Created: new Date(alert.created),
        Type: alert.type,
        Data: alert.data,
        ItemID: alert.entityUuid,
        BodyOfWaterUUID: alert.bodyUuid,
        State: alert.state
    };

    return rec;
}
export function recordFromLocal(alert):AlertRecord {
    let rec = new AlertRecord({
        uuid: alert.UUID,
        created: new Date(alert.Created),
        type: alert.Type,
        data: alert.Data,
        entityUuid: alert.ItemID || alert.ItemId,
        bodyUuid: alert.BodyOfWaterUUID,
        state: alert.State,
    });

    return rec;
}